/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { baseRequest } from 'id-api/baseRequest';

let CONFIG: Identity.API.Config;

export const getConfig = () => CONFIG;

export const getConfigs = async (): Promise<Identity.API.Config> => {
  const { data } = await baseRequest.get('/app-config?featureFlags=true&auth=true');
  return data;
};

export const getAuthConfig = async (): Promise<Identity.API.AuthConfig> => {
  const { data } = await baseRequest.get('/app-config?auth=true');
  return data.auth;
};

export const loadConfig = async () => {
  const { data } = await baseRequest.get('/app-config');
  CONFIG = data;
};
